export const DEFAULT_CRITERIA_MODE = 'all';

export const DEFAULT_REVALIDATE_MODE = 'onChange';

export enum FieldNames {
  Deposit = 'deposit',
  TokenSymbol = 'TokenSymbol',
  Amount = 'amount',
  Percent = 'percent',
  Token = 'token',
  Title = 'title',
  PublisherName = 'publisherName',
  Description = 'description',
  Address = 'address',
  Link = 'link',
}
